// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#body[data-v-f1d8a83c]{display:-webkit-box;display:-ms-flexbox;display:flex;min-height:100vh;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}main[data-v-f1d8a83c]{-webkit-box-flex:1;-ms-flex:1;flex:1}.inbox-count[data-v-f1d8a83c]{position:relative;bottom:1px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
